var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRasgadosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 50,
    viewBox: "0 0 357 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.782 0.279785H146.177V10.264H168.782V0.279785Z",
    fill: "#8E2A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.966 10.3081L146.18 0.277832V34.2653H134.966V10.3081Z",
    fill: "#C0392B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.925 19.0457H153.638V30.2369H161.925V19.0457Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.903 19.0408L173.293 30.3705L173.168 34.4662L161.903 46.1716L161.903 19.0408Z",
    fill: "#FF5442"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.951 34.2666H161.92V46.0339H146.795L134.951 34.2666Z",
    fill: "#E74C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.339 8.79224H1.29041V45.9153H12.339V8.79224Z",
    fill: "#8E2A20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8884 12.5815H49.2634V45.9749H60.8884V12.5815Z",
    fill: "#C0392B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2634 12.6129H73.6384V45.962H85.2634V12.6129Z",
    fill: "#C0392B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5134 21.6441L74.5759 21.5818L85.2634 33.4568H46.5134V21.6441Z",
    fill: "#E74C3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9133 0.0188981L73.6317 0L85.2993 12.6263H49.2451L60.9133 0.0188981Z",
    fill: "#E74C3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.951 0.581543H227.076V45.8315H238.951V0.581543Z",
    fill: "#C0392B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.326 0.144074L253.078 0.0998535L264.701 12.269H224.326V0.144074Z",
    fill: "#E74C3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264.701 12.2692H252.638V33.9567H264.701V12.2692Z",
    fill: "#C0392B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.308 13.3418H181.683V46.0722H193.308V13.3418Z",
    fill: "#C0392B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M217.683 13.373H206.058V46.0151H217.683V13.373Z",
    fill: "#C0392B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M178.933 22.4043L206.995 22.3419L217.683 34.2169H178.933V22.4043Z",
    fill: "#E74C3C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.333 0.249484L206.051 0.226807L217.719 13.3834H181.665L193.333 0.249484Z",
    fill: "#E74C3C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M354.058 0.39502H330.128V9.92091H354.058V0.39502Z",
    fill: "#C0392B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M320.646 9.96159L330.128 0.41333V28.3731L320.646 19.9223V9.96159Z",
    fill: "#E74C3C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M356.706 28.3691H344.862V36.57H356.706V28.3691Z",
    fill: "#8E2A20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M330.129 19.9023L344.933 19.9447L356.712 28.3697H330.129V19.9023Z",
    fill: "#C0392B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M321.156 36.5518H356.69L345.005 45.9684L321.156 45.906V36.5518Z",
    fill: "#E74C3C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.326 33.8942H264.701L252.881 46.045L224.326 46.0186V33.8942Z",
    fill: "#E74C3C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M282.282 0.206665H302.907L314.657 11.8133H270.282L282.282 0.206665Z",
    fill: "#E74C3C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M270.263 34.4254H314.638L302.67 45.8942L282.17 45.9566L270.263 34.4254Z",
    fill: "#E74C3C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.28 11.7775H270.342V34.4449H282.28V11.7775Z",
    fill: "#C0392B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M314.638 11.7946H302.701V34.462H314.638V11.7946Z",
    fill: "#C0392B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.897 0.178101H0V10.5687H26.897V0.178101Z",
    fill: "#C0392B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 21.951H39.43L26.887 30.7346H11.3667V21.951Z",
    fill: "#C0392B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3927 22.0126L43.4549 39.975L37.661 49.783L5.30774 30.4247L11.3927 22.0126Z",
    fill: "#E74C3C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8883 0.179565L39.4282 10.5043L39.4596 21.9017L26.8884 30.7383L26.8883 0.179565Z",
    fill: "#E74C3C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M125.83 0.482422H101.9V10.0083H125.83V0.482422Z",
    fill: "#C0392B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4183 10.049L101.9 0.500732V28.4605L92.4183 20.0097V10.049Z",
    fill: "#E74C3C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M128.478 28.4565H116.634V36.6574H128.478V28.4565Z",
    fill: "#8E2A20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.901 19.9897L116.705 20.0321L128.484 28.4571H101.901V19.9897Z",
    fill: "#C0392B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9285 36.6392H128.462L116.777 46.0558L92.9285 45.9934V36.6392Z",
    fill: "#E74C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRasgadosLogo);
export default __webpack_public_path__ + "static/media/RasgadosLogo.18e01f86aaef0ba413eb5dbbe3ad63b2.svg";
export { ForwardRef as ReactComponent };